// extracted by mini-css-extract-plugin
export default {"ingrediensblock":"cY","heading":"eY","item":"fY","fadeIn":"gY","imagewrapper":"hY","modalheader":"iY","amount":"jY","name":"kY","desc":"lY","moredetails":"mY","ingheader":"nY"};
    if(module.hot) {
      // 1713809679486
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  